<template>
  <el-button v-if="items.length > 0"
    type="success"
    @click="clicked">
    <i class="fa fa-money">&nbsp;</i>
      Fully Pay <strong>{{items.length}}</strong> item{{items.length > 1 ? 's' : ''}}
  </el-button>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    clicked () {
      this.$alert('This will mark "Paid" all selected items.', 'Under Development')
    }
  }
}
</script>



// WEBPACK FOOTER //
// PayAllButton.vue?6e82532a